import React, { useState } from 'react';

import { useMutation } from '@tanstack/react-query';

import Modal from '../../../../../Modal';
import Table from '../../../../../Table';
import TransactionEditModal from './TransactionEditModal';

import { useUiStore } from '../../../../../../store';
import useUserRole from '../../../../../../hooks/useUserRole';
import BankStatementTransactionService from '../../../../../../services/BankStatementTransactionService';

const cols = [
  {
    title: 'Date',
    key: 'date',
    type: 'date',
  },
  {
    title: 'Description',
    key: 'description',
  },
  {
    title: 'Deposit Amount',
    key: 'depositAmount',
    type: 'currency',
  },
  {
    title: 'Deduction Amount',
    key: 'deductionAmount',
    type: 'currency',
  },
  {
    title: 'Excluded',
    key: 'isExcluded',
    type: 'boolean',
    format: (value) => (value ? 'Yes' : 'No'),
  },
  {
    title: 'Exclusion Reason',
    key: 'exclusionReason',
  },
];

export default function TransactionsTableModal({
  isVisible,
  hideModal,
  transactions,
  refetch,
}) {
  const [isTransactionEditModalVisible, setIsTransactionEditModalVisible] =
    useState(false);
  const [currentTransaction, setCurrentTransaction] = useState(null);

  const showDialogModal = useUiStore((state) => state.showDialogModal);
  const notify = useUiStore((state) => state.notify);

  const { isOwner, isSuperAdmin } = useUserRole();

  const { mutate: deleteTransaction } = useMutation({
    mutationFn: (transactionId) =>
      BankStatementTransactionService.deleteBankStatementTransaction(
        transactionId
      ),
    onSuccess: async () => {
      await refetch();
      notify({ type: 'success', message: 'Transaction deleted successfully' });
    },
    onError: (error) => {
      console.log(error);
      notify({ type: 'error', message: 'Error deleting transaction' });
    },
  });

  const actions = [
    {
      title: 'Edit',
      onClick: (row) => {
        setCurrentTransaction(row);
        setIsTransactionEditModalVisible(true);
      },
      icon: 'edit',
    },
    {
      title: 'Delete',
      onClick: (row) =>
        showDialogModal({
          title: 'Delete Document',
          text: `Are you sure you want to delete this document?`,
          onConfirm: () => deleteTransaction(row.id),
        }),
      icon: 'delete',
      danger: true,
    },
  ];

  return (
    <>
      <Modal isVisible={isVisible} hideModal={hideModal} title="Transactions">
        <div>
          <Table
            cols={cols}
            rows={transactions}
            actions={isOwner || isSuperAdmin ? actions : []}
            countName="Transactions"
            style={{
              maxHeight: '80vh',
            }}
          />
        </div>
      </Modal>
      <TransactionEditModal
        isVisible={isTransactionEditModalVisible}
        hideModal={() => setIsTransactionEditModalVisible(false)}
        transaction={currentTransaction}
        refetch={refetch}
      />
    </>
  );
}
